import {useFlags as useLDFlags} from 'launchdarkly-react-client-sdk';

export const useFlags = () => {
  const flags = useLDFlags();

  // Rename the LaunchDarkly flag names
  return {
    showBrowser: !!flags.acornsShowBrowser,
    showCreateNewOrder: !!flags.acornsShowCreateNewOrder,
    showCreateSubscription: !!flags.acornsShowCreateSubscription,
    showMapRoutes: !!flags.acornsShowMapRoutes,
    notificationsInPlatformApps: !!flags.notificationsInPlatformApps,
    showNotificationSettingsButton: !!flags.accountEnableNotificationSettings,
  };
};
